import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4639ccfb&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=4639ccfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639ccfb",
  null
  
)

export default component.exports